import { Button } from "components/DesignSystem/Button/Button";
import { Padlock } from "components/icons/Padlock";
import { ComponentProps, ReactNode } from "react";

export const BlockedButton = (props: ComponentProps<typeof Button>) => (
  <Button disabled icon={<Padlock />} {...props} />
);
